import React, { Component } from "react";
import FlashMessage from "../../FlashMessage";
import "./style.css";

class HomePage extends Component {
  constructor(props) {
    super(props);
    this.state = { message: undefined };
    this.removeFlash = this.removeFlash.bind(this);
  }

  removeFlash() {
    this.setState({ message: undefined });
  }

  render() {
    return (
      <div className="zkrin-container">
        {this.state.message && (
          <FlashMessage removeFlash={this.removeFlash} {...this.state.message} />
        )}
        <div className="flex-grid">
          <a className="dash-btn" href="dashboards/sales">
            Sales Dashboard
          </a>
        </div>
        <div className="flex-grid">
          <a className="dash-btn" href="dashboards/factory">
            Factory Dashboards
          </a>
        </div>
        <div className="flex-grid">
          <a className="dash-btn" href="dashboards/tech-server">
            Server
          </a>
        </div>
        <div className="flex-grid">
          <a className="logout-btn" href="https://zkrin-api2.cheerz.com/admin/logout">
            Sign-Out{" "}
            <span role="img" aria-label="Lock">
              🔒
            </span>
          </a>
        </div>
      </div>
    );
  }
}

export default HomePage;
